<template>
	<div>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Cadastro</h1>

			<div>
				<button class="btn btn-sm btn-success" @click="open_cad_modal">Cadastrar</button>
			</div>
	    </div>

	    <alert ref="alert" />

		<ul class="nav nav-tabs" role="tablist" style="margin-bottom: 5px;">
	        <li class="nav-item">
	        	<router-link :to="{name: 'Usuarios', params: {get: 'Usuarios'} }" class="nav-link active" data-toggle="tab">Usuários</router-link>
	        </li>

	        <li class="nav-item">
	        	<router-link :to="{name: 'Setores', params: {get: 'Setores'} }" class="nav-link" data-toggle="tab">{{view_nome.setor_nome}}</router-link>
	        </li>

	        <li class="nav-item">
	        	<router-link :to="{name: 'Ramais', params: {get: 'Ramais'} }" class="nav-link" data-toggle="tab">Ramais</router-link>
	        </li>
	    </ul>

	    <div class="row">
	        <div class="col-12">
	            <div class="tab-content">
	            	<transition mode="out-in" name="leftIn">
						<router-view 
							@alert="show_alert"
							ref="contentCAD" 
							:key="get" 
							:pdf.sync="pdf_btn" 
							:pdf_title.sync="pdf_title"
							:pdf_datatable.sync="pdf_datatable"
							:pdf_external.sync="pdf_external"
							:pdf_header.sync="data_head"
							:pdf_body.sync="data_body"
							:pdf_string_filter.sync="string_filter"
						></router-view>
					</transition>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
	import alert  from "@/components/Tools/alert.vue"
	import pdfBtn from "@/components/Tools/Pdf.vue"
	import api    from "@/mixins/api.js"

	export default {
		name: "Cadastro",
		props: ["get"],
		mixins: [ api ],
		components: { alert, pdfBtn },

		beforeRouteUpdate(to, from, next) {
			next();
		},

		data() { 
			return {
				alert: { type: "", msg: "" },
				string_filter: "",
				data_head: [],
				data_body: [],
				pdf_external: true,
				pdf_btn: false,
				pdf_title: "",
				pdf_datatable: ""
			}
		},

		computed: {
			view_nome(){ 
				return this.$store.state.config_view_menu;
			},
		},

		methods: {
			open_cad_modal() {
				this.$refs.contentCAD.add();
			},

			show_alert(payload) {
				if ( payload.status == "success") {
					this.$refs.alert.alert('Dados salvos com sucesso!', 'alert-success');
				}
				else{ 
					this.$refs.alert.alert('Problemas ao salvar dados!', 'alert-danger');
				}
			},
		}
	};
</script>

<style>
</style>